import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BACKEND_URL, getSessionId } from '../lib/utils';

const CONSENT_KEY = 'scanmarket_cookie_consent_v1';

/**
 * Flag globale per tracking identificativo (IP + UA completi, session recording, etc.).
 * Quando false → tracking aggregato anonimo comunque attivo lato backend (IP mascherato /24).
 * Questa funzione è usata dal backend endpoint /api/track tramite flag `consent`.
 */
export function isTrackingEnabled() {
  if (typeof window === 'undefined') return false;
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return false;
    const p = JSON.parse(raw);
    if (!p || p.status !== 'accepted') return false;
    if (p.expiresAt && new Date(p.expiresAt).getTime() < Date.now()) return false;
    return !!p.analytics;
  } catch {
    return false;
  }
}

export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    // Backend tracking sempre attivo, ma il body trasporta il flag `consent`
    // così il backend può decidere quanto conservare (IP intero vs /24, UA, etc.)
    try {
      const referrer = document.referrer || '';
      const cleanRef = referrer.includes(window.location.host) ? '' : referrer;
      fetch(`${BACKEND_URL}/api/track`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: pathname,
          referrer: cleanRef,
          session_id: getSessionId(),
          consent: isTrackingEnabled(),
        }),
      }).catch(() => {});
    } catch {}
  }, [pathname]);
  return null;
}
